import React from 'react'

import PerfectScrollbar from 'react-perfect-scrollbar'

import { Paper, Box, TablePagination } from '@material-ui/core'

import { Skeleton } from '@material-ui/lab'

import { Container, ContentHeader, TableHeader, Filters } from 'components'
import TaxInvoicesTable from './components/TaxInvoicesTable'
import * as service from 'service'
import useFetch from 'hooks/useFetch'
import usePagination from 'hooks/usePagination'
import useFilter from 'hooks/useFilter'
import moment from 'moment'

const TaxInvoicesMain = () => {
  const filter = useFilter()

  const {
    perPage,
    page,
    handleChangePage,
    handleChangeRowsPerPage,
  } = usePagination(20)

  const { response, isLoading } = useFetch(
    service.recurrence.taxInvoices.get,
    { perPage, page, ...{ serviceTaxInvoice: { ...filter.filters } } },
    [page, filter.filters],
  )

  return (
    <Container>
      <ContentHeader title="Notas Fiscais" subtitle="Listagem" />
      <Paper>
        <TableHeader
          setDrawerOpen={filter.setDrawerOpen}
          downloadable={true}
          fnDownload={service.recurrence.taxInvoices.downloadCsv}
          paramsDownload={{
            perPage,
            page,
            ...{ serviceTaxInvoice: { ...filter.filters } },
          }}
          fileName={
            'NotaFiscal_' +
            moment(new Date())
              .utc(false)
              .format('DD-MM-YYYY') +
            '.csv'
          }
        />

        <PerfectScrollbar>
          <TaxInvoicesTable
            serviceTaxInvoices={response && response.data.serviceTaxInvoices}
            isLoading={isLoading}
          />
        </PerfectScrollbar>

        <Box px={2} display="flex" justifyContent="flex-end">
          {response ? (
            <TablePagination
              component="div"
              count={response.data.meta.totalCount}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
              page={page - 1}
              rowsPerPage={perPage}
              rowsPerPageOptions={[5, 10, 20, 30, 40, 50]}
              labelRowsPerPage="Por página"
              nextIconButtonProps={{ size: 'small' }}
              backIconButtonProps={{ size: 'small' }}
            />
          ) : (
            <Box py="11px">
              <Skeleton variant="rect" width={200} height={30} />
            </Box>
          )}
        </Box>
      </Paper>

      <Filters filter={filter}>
        <input label="Identificador" textfieldinput="true" name="id" />
        <input
          label="Identificador da fatura"
          textfieldinput="true"
          name="invoiceId"
        />
        <input
          label="Número da Nota Fiscal"
          textfieldinput="true"
          name="nfId"
        />
        <input
          label="Email do Cliente"
          textfieldinput="true"
          name="customer[customerEmail]"
        />
        <input currencyinput="true" label="Valor Inicial" name="amount_gt" />
        <input currencyinput="true" label="Valor Final" name="amount_lt" />
        <input
          datepickerinput="true"
          label="Data de emissão inicial"
          name="created_at_gt"
        />
        <input
          datepickerinput="true"
          label="Data de emissão final"
          name="created_at_lt"
        />
        <select label="Status" textfieldinput="true" name="status">
          <option value=""></option>
          <option value="2">Pendente de emissão</option>
          <option value="5">Pendente de emissão NFE.io</option>
          <option value="1">Emitida</option>
          <option value="6">Erro ao emitir</option>
          <option value="4">Pendente de cancelamento</option>
          <option value="3">Cancelado</option>
        </select>
      </Filters>
    </Container>
  )
}

export default TaxInvoicesMain
